import { atomFamily, selectorFamily } from 'recoil'

import { OrderResponseData } from 'types/api/order-response'

const orderResponses = atomFamily<Partial<OrderResponseData>, string>({
  key: 'OrderResponses',
  default: (param) => ({ ClOrdID: param }),
})

const orderReponseSelector = selectorFamily({
  key: 'OrderResponseSelector',
  get:
    (orderId: string) =>
    ({ get }) => {
      return get(orderResponses(orderId))
    },
  set:
    (orderId) =>
    ({ set }, newValue) => {
      set(orderResponses(orderId), newValue)
    },
})

export const tradeSlice = {
  orderResponses,
  orderReponseSelector,
}
